import { Component, ViewChild } from "@angular/core";
import { IonicPage, NavController, NavParams, ModalController, AlertController, LoadingController } from "ionic-angular";

import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";
import "rxjs/add/operator/mergeMap";
import * as _ from "lodash";
import { UtilityProvider } from "../../providers/utility/utility";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Subject } from "rxjs";
import * as XLSX from 'xlsx';
import moment from "moment";

@IonicPage()
@Component({
  selector: 'page-report-dispensing',
  templateUrl: 'report-dispensing.html',
})
export class ReportDispensingPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  displayedColumns = ['patient.program_patient_id', 'patient.first_name', 'patient.last_name', 'therapy', 'indication', 'dose', 'first_fill_date', 'fill_date', 'quantity'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  program_name: string;
  program_id: string;
  userid: string;
  user_fullname: string;
  dispensing: any[] = [];
  exportjson: any[] = [];
  dispensejson: any[] = [];

  constructor(
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public utility: UtilityProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.userid = user.id;
      this.user_fullname = user.first_name + ' ' + user.last_name;
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.database.getDispensingFromProgramwithPatient(this.program_id)
      .takeUntil(this.ngUnsubscribe)
      .subscribe((dispensing: Array<any>) => {
        let dis = [];
        dispensing.forEach(item => {
          let patient = item[`program/${this.program_id}/patients`][0];
          item.patient.address = patient.address;
          item.patient.city = patient.city;
          item.patient.province = patient.province;
          item.patient.postal_code = patient.postal_code;
          item.patient.status = patient.status;
          item.reimbursement_type = this.utility.getReimbursementType(patient.reimbursement_private, patient.reimbursement_private_other, patient.reimbursement_public, patient.reimbursement_compassionate, patient.reimbursement_fa);
          item.reimbursement_status = this.utility.getReimbursementActiveType(patient.reimbursement_private, patient.reimbursement_private_other, patient.reimbursement_public);
          delete item[`program/${this.program_id}/patients`]
          dis.push(item);
        })
        this.exportjson = dis;
        this.dataSource = new MatTableDataSource(this.exportjson);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (data, sortHeaderId: string) => {
          return this.getPropertyByPath(data, sortHeaderId);
        };
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave dispensing report view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getPropertyByPath(obj: Object, pathString: string) {
    return pathString.split('.').reduce((o, i) => o[i], obj);
  }

  exportDispensing()  {
    let dispensejson = [];
    this.exportjson.filter(d => {
      const dispense_date = d.fill_date ? d.fill_date : null;
      const dispense = { 
        'Patient ID': d.patient.program_patient_id,
        'Dispensing Pharmacy': d.pharmacy ? d.pharmacy.name : null,
        'Patient City Delivered to': d.patient ? d.patient.city : null,
        'Patient Province Delivered to': d.patient ? d.patient.province : null,
        'Patient Postal Code Delivered to': d.patient ? d.patient.postal_code : null,
        'Product Name': d.therapy ? d.therapy: null,
        'Product Strength': d.dose ? d.dose : null,
        'Drug Type': d.drug_type ? d.drug_type : null,
        'Quantity': d.quantity,
        'Dispensed Date': dispense_date ? moment(dispense_date.seconds * 1000).format('DD-MMM-YYYY') : null,
        'Dispensed Date (month & year)': dispense_date ? moment(dispense_date.seconds * 1000).format('MMM-YYYY') : null,
        'Dispensed Date: Month': dispense_date ? moment(dispense_date.seconds * 1000).month()+1 : null,
        'Dispensed Date: Qtr': dispense_date ? moment(dispense_date.seconds * 1000).quarter() : null,
        'Dispensed Date: Year': dispense_date ? moment(dispense_date.seconds * 1000).year() : null,
        'Dispensed Date: Week': dispense_date ? moment(dispense_date.seconds * 1000).week() : null,
        'Patient Status': d.patient ? d.patient.status : null,
        'Reimbursement Type': d.reimbursement_type ? d.reimbursement_type : null,
        'Reimbursement Status': d.reimbursement_status ? d.reimbursement_status : null,
        'Physician First Name': d.doctor ? d.doctor.first_name : null,
        'Physician Last Name': d.doctor ? d.doctor.last_name : null,
        'Physician Hospital': d.clinic ? d.clinic.name : null,
        'Physician Province': d.clinic ? d.clinic.province : null,
        'Physician Vector Id': d.doctor ? d.doctor.program_physician_id : null,
        'Created': d.createdAt ? d.createdAt.toDate() : null
      }
      dispensejson.push(dispense)
    });
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(dispensejson);
    workSheet['!autofilter'] = { ref: "A1:BG1" };
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Dispensing'); // add the worksheet to the book
    XLSX.writeFile(workBook, moment().format('YYYY-MMM-DD-HHssA') + '-dispensing.xlsx'); // initiate a file download in browser
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-dispensing/report-dispensing.ts